<div class="row">
    <div class="col-md-12">
        <div class="card" *ngIf="receiptData">
            <div class="row">
                <div class="col-md-6">
                    <h5 class="headingValue">View Receipt</h5>
                </div>
                <div class="col-md-6 text-right">
                    <button type="button" class="btn btn-primary" style="cursor: pointer;" (click)="navigateBack()"><span><i
                                class="fas fa-angle-left"></i></span>&nbsp;Back</button>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-3">
                    <b> <label>Diary Date</label></b>
                    <p>{{receiptData.receiptDairyDate !==undefined ? (receiptData.receiptDairyDate):'-'}}</p>
                </div>
                <div class="col-md-3">
                    <b> <label>Ref.Id</label></b>
                    <p> {{receiptData.receiptFileNum !==null ? (receiptData.receiptFileNum.dakDispatchFileNo) : '-'}}</p>
                </div>
                <div class="col-md-3">
                    <b> <label>Receipt Category</label></b>
                    <p>{{receiptData.dispatchCategories !== null ? (receiptData.dispatchCategories.name):'-'}}</p>
                </div>
                <div class="col-md-3">
                    <b> <label>Receipt Language</label></b>
                    <p>{{receiptData.receiptLanguageId.name}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <b> <label>Date Received</label></b>
                    <p>{{receiptData.dairyReceivedDate}}</p>
                </div>
                <div class="col-md-3">
                    <b> <label>Sender Name</label></b><br>
                    <p>{{receiptData.senderName}}</p>
                </div>
                <div class="col-md-6 wordBreak">
                    <b> <label>Subject</label></b>
                    <p>{{receiptData.receiptSubject}} </p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <b> <label>Urgency </label></b><br>
                    <p>{{receiptData.dispatchUrgency !== null ? receiptData.dispatchUrgency.name : '-'}}</p>
                </div>
                <div class="col-md-3">
                    <b> <label>Confidentiality </label></b>
                    <p>{{receiptData.dispatchConfidentialityType !== null ? receiptData.dispatchConfidentialityType.name: '-'}}</p>
                </div>
                <div class="col-md-6">
                    <b> <label>Complete By </label></b>
                    <p>{{(receiptData.dispatchByDate !== null && receiptData.dispatchByDate !== '') ? (receiptData.dispatchByDate | date:'dd-MM-yyyy') : '-'}} </p>
                </div>
            </div>
            <hr>
            <div  class="row">
                <div class="col-md-12" >
                    <h5 class="headingValue" >Acknowledgement</h5>
                </div>
                <br>
                <div class="col-md-3">
                    <b> <label>Letter No.</label></b>
                    <p>{{(receiptData?.letterNo != "" && receiptData?.letterNo != null) ? receiptData?.letterNo : '-'}}
                </div>
                <div class="col-md-3">
                    <b> <label>Date of Letter</label></b>
                    <p>{{(receiptData?.letterDate != "" && receiptData?.letterDate != null) ? receiptData?.letterDate : '-'}}
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-6">
                    <b> <label>Assigned To Whom</label></b><br>
                   <p *ngFor="let section of primarywithsectionName">Section Head - {{section?.role?.section?.sectionName}} <span style="margin:0px;"
                    *ngIf="section.isPrimary === 1">
                   (Primary) </span></p> 
                </div>
                <div class="col-md-6">
                    <b> <label>Address</label></b><br>
                    <span>
                        <p style="margin:0px; margin-left:10px !important;"
                        *ngIf="receiptData.dakAddressCategories !==undefined ||receiptData.dakAddressCategories !==null">
                       <span style="margin:0px;" *ngIf="receiptData.dakAddressCategories.addressCategoryId === 7  && (receiptData.userMaster.fullName !==undefined ||receiptData.userMaster.fullName !==null)">
                        The Registrar,</span>
                        <span style="margin:0px;" *ngIf="receiptData.dakAddressCategories.addressCategoryId !== 1 && receiptData.dakAddressCategories.addressCategoryId !== 2 && receiptData.dakAddressCategories.addressCategoryId !== 3  && receiptData.dakAddressCategories.addressCategoryId !== 4 && receiptData.dakAddressCategories.addressCategoryId !== 7 && receiptData.dakAddressCategories.addressCategoryId !== 6 && (receiptData.userMaster.fullName !==undefined ||receiptData.userMaster.fullName !==null)">
                            {{receiptData.userMaster.fullName !== null ? (receiptData.userMaster.fullName) :'-'}},</span>
                        <span style="margin:0px;" *ngIf="receiptData.dakAddressCategories.addressCategoryId === 1 && (receiptData.userMaster.fullName !==undefined ||receiptData.userMaster.fullName !==null)">
                             The Principal/Dean, </span>
                            <span *ngIf="receiptData.dakAddressCategories.addressCategoryId === 4">
                            The Secretary to the Govt. of India,
                            </span> 
                            <span *ngIf="receiptData.dakAddressCategories.addressCategoryId === 6">
                               Others,
                                </span>
                     
                            <span *ngIf="receiptData.dakAddressCategories.addressCategoryId === 3">
                                The Health Secretary,
                            </span>    
                          
                            <span *ngIf="receiptData.dakAddressCategories.addressCategoryId === 2">
                           The Director,
                            </span>    
                             &nbsp;(<span style="margin:0px;"
                        *ngIf="receiptData.receiptVia !==undefined ||receiptData.receiptVia !==null">via {{receiptData.receiptVia !== null ? (receiptData.receiptVia.name) :'-'}}</span>)</p>
                        <span style="margin:0px; margin-left:10px !important;" *ngIf="receiptData.dakAddressCategories.addressCategoryId === 1 || receiptData.dakAddressCategories.addressCategoryId === 2 || receiptData.dakAddressCategories.addressCategoryId === 7 || receiptData.dakAddressCategories.addressCategoryId === 8">{{receiptData.userMaster?.entityMaster?.name}},<br></span>    
                        <span style="margin:0px; margin-left:10px !important;" *ngIf="receiptData.dakAddressCategories.addressCategoryId === 4">Ministry of Health and Family Welfare,<br></span> 
                            <span style="margin:0px; margin-left:10px !important;" *ngIf="receiptData.dakAddressCategories.addressCategoryId === 5">
                                {{receiptData.dakAddressCategories !== null ? (receiptData.dakAddressCategories.name) :'-'}},<br></span>  
                            <p style="margin:0px; margin-left:10px !important;"
                                *ngIf="receiptData.senderAddress !==null">
                                {{receiptData.senderAddress !== null ? (receiptData.senderAddress.line1) :''}}<span *ngIf="receiptData.senderAddress.line1 !== '' && receiptData.senderAddress.line1 !== null">,<br></span>
                                {{receiptData.senderAddress !== null ? (receiptData.senderAddress.line2) :''}}<span *ngIf="receiptData.senderAddress.line2 !== '' && receiptData.senderAddress.line2 !== null">,<br></span>
                                {{receiptData.senderAddress !== null ? (receiptData.senderAddress.city) :''}}<span *ngIf="receiptData.senderAddress.city !== '' && receiptData.senderAddress.city !== null">,</span>
                                {{receiptData.senderAddress !== null ? (receiptData.senderAddress.state) :''}}&nbsp;<span *ngIf="receiptData.senderAddress.state !== '' && receiptData.senderAddress.state !== null">-</span>&nbsp;
                                {{receiptData.senderAddress !== null ? (receiptData.senderAddress.zipCode) :''}}<span *ngIf="receiptData.senderAddress.zipCode !== '' && receiptData.senderAddress.zipCode !== null">.</span>
                            </p>
                            <p style="margin:0px; margin-left:10px !important;"
                            *ngIf="receiptData.toEmail !==undefined ||receiptData.toEmail !==null">
                            {{receiptData.toEmail !== null ? (receiptData.toEmail) :''}}<span *ngIf="receiptData.dakAddressCategories.addressCategoryId === 5">,</span> <span style="margin:0px;"
                            *ngIf="receiptData.dakAddressCategories.addressCategoryId === 5">
                            {{receiptData.contactNumber !== null ? (receiptData.contactNumber) :''}}
                            <span *ngIf="receiptData.dakAddressCategories.addressCategoryId === 5">.</span></span></p>
                       
                    </span> 
                    
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b> <label>Enclosure Details</label></b>
                    <p>{{receiptData.enclosureDetails !=="" ? (receiptData.enclosureDetails) : '-'}}
                    </p>
                </div>
            </div>
            <!-- ///// -->
            <div class="row">
                <div class="col-md-12" *ngFor="let document of receiptData.receiptDocuments ;let i=index">
                    <div class="iconCardReceiptDashboard col-md-12" (click)="getDocumentId(document)">
                        <a (click)="viewDocuments(document.documentLocation, document.documentLocation.split('/').pop())"
                        > <i class="far fa-file-alt docIcons"></i>
                            <span style="cursor: pointer;">
                                {{document.documentLocation.split('/').pop()}}
                                <i class="fas fa-eye" style=" cursor: pointer;color: #3D78BE;"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div><br>

            <hr style="color:black">
            <!-- //Integrate -->
            <div id="demo" class="collapse">
                <div class="row">
                    <div class="col-md-6" *ngFor="let history  of assigngedUserDetails">
                        <h5 class="headingValue">Assign Receipt To</h5>
                        <p>{{history.lastModifiedDate}}</p><br>
                        <b><label>{{history.assignedToUserId.roles[0].roleName}}</label></b>
                        <p>{{ history.assignedToUserId.firstName}}</p>
                        <b><label>Comments</label></b>
                        <p>{{history.comments}} </p>
                    </div>
                    <div class="col-md-6 text-right">
                        <i class="fas fa-minus-circle"></i>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- Return Receipt Modal Ends -->

<div class="modal" id="assignModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title headingValue">Assign To Section Executive</h4>
                <button type="button" class="close" data-dismiss="modal"  (click)="resetValidations()"  style="cursor: pointer;">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <form [formGroup]="assignReceiptForm">

                    <!-- Select Designation -->
                    <div class="row">
                        <div class="col-md-12">
                            <label>Select Designation <span class="aseticcolor">*</span></label>&nbsp;
                            <select class="custom-select-sm" [ngClass]="{ 'is-invalid':  submitted && f.designation.errors }" class="form-control" formControlName="designation" (change)="selectedCorrectionDesignation($event.target.value)">
                                <option value="" disabled selected style="color:orange">Select Designation</option>
                                <option *ngFor="let sc of correctionDesignationList" [value]="sc">
                                    {{sc}}
                                </option>
                            </select>
                            <div *ngIf=" submitted && f.designation.errors" class="invalid-feedback">
                                <div *ngIf=" submitted && f.designation.errors.required">
                                    Designation is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <!-- Selected Person  -->
                        <div class="col-md-12">
                            <label>Select Person <span class="aseticcolor">*</span></label>
                            <select class="custom-select-sm" [ngClass]="{ 'is-invalid':  submitted && f.sectionExecuite.errors }" class="form-control" formControlName="sectionExecuite" [attr.disabled]="disablePerson ? '' : null">
                                <option value="" disabled selected style="color:orange">Select Person</option>
                                <option *ngFor="let person of correctionPersonList" [value]="person.userId">
                                    {{person.firstName}}
                                </option>
                            </select>
                            <div *ngIf=" submitted && f.sectionExecuite.errors" class="invalid-feedback">
                                <div *ngIf=" submitted && f.sectionExecuite.errors.required">
                                    Person is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <label>Comments <span class="aseticcolor">*</span></label>
                            <textarea rows="5" cols="20" maxlength="2000" placeholder="Write Comments" formControlName="comment" class="form-control" [ngClass]="{ 'is-invalid':  submitted && f.comment.errors }">Write Comments</textarea>
                            <div *ngIf=" submitted && f.comment.errors" class="invalid-feedback">
                                <div *ngIf=" submitted && f.comment.errors.required">
                                    Comments is required
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="globalBtn submitBtn"  (click)="assignReceiptToSectionExecutive()" [disabled]="!assignReceiptForm.valid" data-dismiss="modal" style="cursor: pointer;">Assign</button>
            </div>

        </div>
    </div>
</div>